const SlamFanChampionshipNameEnum = {
	AUSTRALIAN_OPEN: 'ausopen',
	FRENCH_OPEN: 'french',
	WIMBLEDON: 'wimbledon',
	US_OPEN: 'uso'
};

export default SlamFanChampionshipNameEnum